import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import { MoneyFormatter } from '@shared/helpers/MoneyFormatter';
import media from '../../../utils/mediaQueries';
import {
  LIGHT_BLUE_GREY, LINKS_COLOR, PALE_CORNFLOWER_BLUE, TEXT_COLOR,
} from '../../../theme';

const ProductBlockItem = styled.div`
  background-color: ${PALE_CORNFLOWER_BLUE};
  color: ${TEXT_COLOR};
  border-radius: 12px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05);
  padding: 12px 20px 16px 20px;
  margin: 24px 0 24px 0;
  display: flex;
  flex-direction: row;
  ${media.mobile`
    flex-direction: column;
    padding: 12px 16px 16px 16px;
  `}
`;

const ProductBlockLink = styled.a`
  border-radius: 6px;
  box-shadow: 0 1px 1px 0 ${LIGHT_BLUE_GREY};
  background-color: white;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.17;
  color: ${LINKS_COLOR};
  padding: 5px 8px 7px 8px;
`;

const ProductBlockTitle = styled.p`
  font-weight: 600;
  margin: 0 0 2px 0px;
`;

const ProductBlockContent = styled.div`
  flex: 1;
  margin-right: 8px;
`;

const ProductBlockRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${media.mobile`
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    margin-top: 12px;
  `}
`;

export const ProductBlock = ({
  title,
  price_in_eurocents,
  url,
}) => (
  <ProductBlockItem>
    <ProductBlockContent>
      <ProductBlockTitle>Tu ne te sens pas encore prêt?</ProductBlockTitle>
      {`Obtiens des accès code en ligne avec ${title} pour
                      ${MoneyFormatter.convertEurocentsToMoneyFormat(price_in_eurocents)}\u00A0€`}
    </ProductBlockContent>
    <ProductBlockRight>
      <ProductBlockLink target="_blank" href={url}>Je m’inscris</ProductBlockLink>
    </ProductBlockRight>
  </ProductBlockItem>
);

ProductBlock.propTypes = {
  url: PropTypes.string.isRequired,
  price_in_eurocents: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
};
